// Recent rooms helper — persists last N studio room codes to localStorage
// so the admin can re-enter previous sessions without retyping codes.

const STORAGE_KEY = 'casaSamba.recentRooms';
const MAX_ROOMS = 8;

const generateCode = () => Math.random().toString(36).substring(2, 8).toUpperCase();

/** Read the recent-rooms list from localStorage. Newest first. */
export const getRecentRooms = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch {
    return [];
  }
};

/** Push a room to the front of the list (deduped by code). */
export const rememberRoom = (code, meta = {}) => {
  if (!code) return;
  try {
    const existing = getRecentRooms().filter((r) => r.code !== code);
    const entry = {
      code,
      role: meta.role || 'host', // 'host' | 'guest'
      label: meta.label || null,
      createdAt: new Date().toISOString(),
    };
    const next = [entry, ...existing].slice(0, MAX_ROOMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // localStorage unavailable — silent no-op
  }
};

/** Remove a single room from the list. */
export const forgetRoom = (code) => {
  try {
    const filtered = getRecentRooms().filter((r) => r.code !== code);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  } catch {}
};

/** Clear the whole list. */
export const clearRecentRooms = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
};

/** Generate a fresh code, remember it, and navigate to the host room. */
export const startFreshRoom = (role = 'host') => {
  const code = generateCode();
  rememberRoom(code, { role });
  const path = role === 'host' ? `/video-room/${code}/host` : `/video-room/${code}`;
  window.location.href = path;
  return code;
};

export const generateStudioRoomCode = generateCode;
